import { render, staticRenderFns } from "./VeJwAnPaiKaoshiModel.vue?vue&type=template&id=6a50a78e&scoped=true"
import script from "./VeJwAnPaiKaoshiModel.vue?vue&type=script&lang=js"
export * from "./VeJwAnPaiKaoshiModel.vue?vue&type=script&lang=js"
import style0 from "./VeJwAnPaiKaoshiModel.vue?vue&type=style&index=0&id=6a50a78e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50a78e",
  null
  
)

export default component.exports